import * as swcHelpers from '@swc/helpers';
import { DataLayer } from '@grandvisionhq/analytics';

const eventName = 'wishlist_click';
const wishlistButtonEventMapping = {
    pdp: {
        siteFeature: 'product_detail_page',
        add: 'wishlist_pdp_add_click',
        remove: 'wishlist_pdp_remove_click'
    },
    plp: {
        siteFeature: 'product_list_page',
        add: 'wishlist_plp_add_click',
        remove: 'wishlist_plp_remove_click'
    },
    crossSell: {
        siteFeature: 'product_detail_page',
        add: 'wishlist_pdp_cross_sell_add_click',
        remove: 'wishlist_pdp_cross_sell_remove_click'
    },
    recentlyViewedProducts: {
        siteFeature: 'recently_viewed_products',
        add: 'wishlist_plp_recently_viewed_add_click',
        remove: 'wishlist_plp_recently_viewed_remove_click'
    }
};
const getWishlistButtonEventInfo = (action, location)=>{
    var ref, ref1;
    const interactionType = location ? (ref = wishlistButtonEventMapping[location]) === null || ref === void 0 ? void 0 : ref[action] : undefined;
    const siteFeature = location ? (ref1 = wishlistButtonEventMapping[location]) === null || ref1 === void 0 ? void 0 : ref1.siteFeature : undefined;
    return {
        interactionType,
        siteFeature
    };
};
const pushWishlistEvent = (event)=>{
    const { siteFeature , interactionType , messageType , userLogged , item  } = event;
    DataLayer.pushEvent(swcHelpers.objectSpread({
        event: eventName,
        site_feature: siteFeature,
        interaction_type: interactionType
    }, item ? {
        item: {
            item_sku: item.sku
        }
    } : null, messageType ? {
        message_type: messageType
    } : null, userLogged ? {
        user_logged: userLogged
    } : null));
};

export { eventName, getWishlistButtonEventInfo, pushWishlistEvent };
//# sourceMappingURL=wishlist.js.map
